import { createContext } from 'react'
import Link from 'next/link'
import router from 'next/router'

export const RouterContext = createContext({ Link, router })
